import styles from '../GalleryModal.module.scss';
import type { GalleryImage } from '../utils';

interface GalleryModalImageProps {
  image: GalleryImage;
}

const GalleryModalImage: React.FC<GalleryModalImageProps> = ({ image }) => {
  const pictureElement = (
    <picture>
      {image.webpSrc && <source srcSet={image.webpSrcSet || image.webpSrc} type="image/webp" />}
      <img
        src={image.src}
        srcSet={image.srcSet}
        alt={image.alt}
        width={image.width}
        height={image.height}
        className={styles.image}
      />
    </picture>
  );

  if (!image.caption) {
    return pictureElement;
  }

  return (
    <figure className={styles.figure}>
      {pictureElement}
      <figcaption className={styles.caption}>{image.caption}</figcaption>
    </figure>
  );
};

export default GalleryModalImage;
